import React, { memo } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import { FLEX } from '@v4/constants/quiz'
import EditableHTML from '@v4/components/common/EditableHTML'
import WhiteThemeProvider from '@v4/components/sections/Question/Components/WhiteThemeProvider'
import { useSlider } from './Slider.hooks'
import SubmitButton from '../../components/SubmitButton'
import { ScoreSlider } from './Slider.styled'

const SliderType = props => {
	const [
		{ classes, min, max, value, step, labels, pending, justify, shadow, valueLabelDisplay, withLabels },
		{ handleChange, handleSubmit, valueLabelFormat },
	] = useSlider(props)

	return (
		<Box className={clsx(classes.root, 'q-slider')}>
			<WhiteThemeProvider>
				<ScoreSlider
					min={min}
					max={max}
					step={step}
					value={value}
					marks={false}
					valueLabelDisplay={valueLabelDisplay}
					valueLabelFormat={valueLabelFormat}
					onChange={handleChange}
				/>
				{withLabels && (
					<Box
						className={clsx(classes.labels, 'q-slider-marks')}
						display="flex"
						justifyContent="space-between"
						color="inherit"
					>
						{_.map(labels, ({ text }, index) => (
							<EditableHTML
								html={text || ''}
								key={index}
								className={clsx(classes.label, 'q-slider-mark')}
								variant="body1"
								component="span"
								shadow={shadow}
								displayEmpty
							/>
						))}
					</Box>
				)}
			</WhiteThemeProvider>
			<Box className="q-slider-button-container" display="flex" mt={2} justifyContent={justify}>
				<SubmitButton loading={pending} className="q-slider-button" onClick={handleSubmit} />
			</Box>
		</Box>
	)
}

SliderType.propTypes = {
	justify: PropTypes.oneOf(Object.values(FLEX)),
	onClick: PropTypes.func,
	pending: PropTypes.bool,
	shadow: PropTypes.bool,
}

SliderType.defaultProps = {
	justify: FLEX.START,
	pending: false,
	shadow: false,
	onClick: () => {},
}

export default memo(SliderType)
